import { SuitabilityBypassAgreementActions } from './suitability-bypass-agreement.action';

export interface ISuitabilityBypassAgreement {
    suitabilityBypassAgreement: {
        cblc: string;
        bovespaAccepted: boolean;
        bmfAccepted: boolean;
        bmfAcceptanceDate: Date;
        bovespaAcceptanceDate: Date;
        createdAt: Date;
        updatedAt: Date;
    };
    pending: boolean;
    error: null
}

export const initialState: ISuitabilityBypassAgreement = {
    pending: false,
    error: null,
    suitabilityBypassAgreement: null
}

export function SuitabilityBypassAgreementReducer(state: ISuitabilityBypassAgreement = initialState, action: any){
    switch( action.type ) {
        // GET
        case SuitabilityBypassAgreementActions.getSuitabilityBypassAgreement:
            return { ...state, pending: true, error: null };

        case SuitabilityBypassAgreementActions.getSuitabilityBypassAgreementSuccess:
            return { ...state, pending: false, error: null, suitabilityBypassAgreement: action.payload.data};

        case SuitabilityBypassAgreementActions.getSuitabilityBypassAgreementError:
            return { ...state, pending: false, error: action.payload };

        // UPDATE
        case SuitabilityBypassAgreementActions.updateSuitabilityBypassAgreementSuccess:
            return { ...state, pending: false, error: null, suitabilityBypassAgreement: action.payload.data};

        case SuitabilityBypassAgreementActions.getSuitabilityBypassAgreementError:
            return { ...state, pending: false, error: action.payload };

        default:
            return state;
    }
}
